export const LANGUAGE_KEY = "language_v1";
export const LANGUAGE_DEFAULT = "pl";
